import { withStyles } from "@material-ui/core";
import React from "react";
import DataGrid from "../../../../dataGrid";
import GridConfig from "./GridConfig";
import styles from "./styles";
class MergedCustomersGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
  }

  render() {
    const { config } = this.gridConfig;
    const { classes, ...rest } = this.props;
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <DataGrid
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          {...rest}
        />
      </div>
    );
  }
}

export default withStyles(styles)(MergedCustomersGrid);
